import { addLoading, removeLoading } from './modules/loading.js';
import { auth, Timestamp } from './modules/firebase';
import { getUserInfo, updateGameInfo, updateUserLoginTime, getPenguinSkins, getLists } from './modules/account.js'
import { loadGameSkins } from './modules/imageCache.js';
import { INIT_PenguinPass } from './penguinPass/penguinPass.js';
import { checkUserAgreement } from './modules/termsPolicy.js';

import gameInfo from './public/gameInfo.json'

let boxClickable = true;
let exitAnimation = false;
let gameData = {}
let upgradeRewardTypes = {}
let upgradeData = {}
let upgrades = {}
let canClick = true
let userData;
let userGameData;
let skinsData;
let gameSkins;
let testingUpgradePoints = 0;

let signedIn = false
let darkMode = false;

function removeBoxEffect(){
    if (exitAnimation){
        const upgradeEffectBox = document.getElementById("upgradeEffectBox")
        const treasureBoxImage = document.getElementById("treasureBoxImage")

        upgradeEffectBox.classList.remove("upgradeEffectBox")
        upgradeEffectBox.innerHTML = ""

        treasureBoxImage.classList.remove("openBoxEffect")
        treasureBoxImage.style.opacity = 1;

        boxClickable = true
        exitAnimation = false
    }
}

function chooseUpgradetoGift(){
    let randomInt = getRandomInt(0,100)
    let upgradesOptions = [];
    let type = ""

    if(randomInt < 20){
        type = "Penguin"
    }

    else if(randomInt < 75){
        type = "Common"
    }

    else if(randomInt < 90){
        type = "Rare"
    }
    
    else{
        type = "Legendary"
    }

    if (type != "Penguin"){
        for (const upgradeReward in upgradeRewardTypes){
            if (upgradeRewardTypes[upgradeReward].rarity == type){
                upgradesOptions.push(upgradeReward)
            }
        }

        randomInt = getRandomInt(0,upgradesOptions.length-2)

        let rewardObject = upgradeRewardTypes[upgradesOptions[randomInt]]

        return([rewardObject, upgradesOptions[randomInt]])
    }

    else{
        randomInt = getRandomInt(0,upgrades.length-1)
        let rewardObject = {
            rarity: "Penguin",
            image: upgradeData[randomInt].name
        }
        return([rewardObject, randomInt])
    }
}

function updateRewards(giftedUpgradeString, giftedUpgrade){
    if (Object.keys(gameData.upgradeRewards).includes(String(giftedUpgradeString))){
        gameData.upgradeRewards[String(giftedUpgradeString)].amount += 1;
    }
    else{
        gameData.upgradeRewards[giftedUpgradeString] = 
        {
            "amount": 1,
        }
    }

    updateRewardElement(giftedUpgradeString, giftedUpgrade.rarity, giftedUpgrade)
    //calculateResetValue()

    if(!signedIn){
        localStorage.setItem('gameData', JSON.stringify(gameData));
    }else{
        syncData()
    }

    document.getElementById("penguinCoinAmount").innerHTML = gameData.upgradePoints
}


export function triggerChest(newGameData, giftedUpgradeString, giftedUpgrade, update){
    gameData = newGameData
    const upgradeEffectBox = document.getElementById("upgradeEffectBox")
    const treasureBoxImage = document.getElementById("treasureBoxImage")

    const effectElementRight = `
        <img src="./images/upgradeIcons/effect${giftedUpgrade.rarity}.png" class="effectParticles" id="effectParticlesRight"> 
    `

    const effectElementLeft = `
    <img src="./images/upgradeIcons/effect${giftedUpgrade.rarity}.png" class="effectParticles" id="effectParticlesLeft"> 
    `
    let newUpgrade = ``

    let path = "upgradeIcons"

    if(giftedUpgrade.rarity === "Penguin"){
        path = "penguins"
    }

    let image = `./images/${path}/${giftedUpgrade.image}.png`

    if(giftedUpgrade.type && (giftedUpgrade.type == "blueberry" || giftedUpgrade.type == "skin")){
        image = giftedUpgrade.image
    }

    if(giftedUpgrade.rarity === "Penguin"){
        image = gameSkins[giftedUpgrade.image]
    }
    newUpgrade = `
    <img src="${image}" id="effectIcon"> 
    `

    upgradeEffectBox.classList.add("upgradeEffectBox")

    setTimeout(()=>{
        treasureBoxImage.classList.add("openBoxEffect")
        setTimeout(()=>{
            treasureBoxImage.style.opacity = 0;
            treasureBoxImage.classList.remove("openBoxEffect")
            upgradeEffectBox.insertAdjacentHTML("beforeend", effectElementRight)
            setTimeout(()=>{
                upgradeEffectBox.insertAdjacentHTML("beforeend", effectElementLeft)
            },200)
            setTimeout(()=>{        
                document.getElementById("effectParticlesRight").style.animation = "rotateParticlesKeyframesRight 50s linear infinite"
                setTimeout(()=>{
                    document.getElementById("effectParticlesLeft").style.animation = "rotateParticlesKeyframesLeft 50s linear infinite"
                    upgradeEffectBox.insertAdjacentHTML("beforeend", newUpgrade)
                    if(update){
                        updateRewards(giftedUpgradeString, giftedUpgrade)
                    }else if(signedIn){
                        syncData()
                    }
                    exitAnimation = true;
                },300)
            },700)
        },1500)
    },1500)
}

function openBoxEffect(){
    if(gameData.upgradePoints > 0 && boxClickable){
        boxClickable = false;

        const giftedUpgradeArray = chooseUpgradetoGift()
        const giftedUpgrade = giftedUpgradeArray[0]
        const giftedUpgradeString = giftedUpgradeArray[1]

        // perform additional actions here
        gameData.upgradePoints -= 1;
        triggerChest(gameData, giftedUpgradeString, giftedUpgrade, true)
    }
}

function updateRewardElement(giftedUpgrade, type, giftedUpgradeObject){
    const elementIcon = document.getElementById(String(giftedUpgrade));

    let path = "upgradeIcons"
    let typeClass = ""
    
    if (type == "Penguin"){
        path = "penguins"
        typeClass = "Penguin"
    }

    // HERE
    if(gameData.upgradeRewards[giftedUpgrade].amount > 0){
        elementIcon.innerHTML = `
            <img class="upgradeIconImageClickable${typeClass}" src="./images/${path}/${giftedUpgradeObject.image}.png" id="${giftedUpgrade}">
            <div class="iconNum upgradeNum">${gameData.upgradeRewards[giftedUpgrade].amount}</div>
        `
    }
    else{
        elementIcon.innerHTML = `
            <img class="upgradeIconImageClickable${typeClass}" src="./images/${path}/${giftedUpgradeObject.image}.png" id="${giftedUpgrade}">
        `
    }
}

let upgradeIcon = ''

async function createUpgrades(){
    for (const upgradeReward in upgradeRewardTypes){

        if(Object.keys(gameData.upgradeRewards).includes(upgradeReward)){
            if(gameData.upgradeRewards[upgradeReward].amount > 0){
                upgradeIcon = `
                    <div class="upgradeIconBox" id="${upgradeReward}">
                        <img class="upgradeIconImageClickable" src="./images/upgradeIcons/${upgradeRewardTypes[upgradeReward].image}.png" id="${upgradeReward}">
                        <div class="iconNum upgradeNum">${gameData.upgradeRewards[upgradeReward].amount}</div>
                    </div>
                `
            }else{
                upgradeIcon = `
                    <div class="upgradeIconBox" id="${upgradeReward}">
                        <img class="upgradeIconImage" src="./images/upgradeIcons/${upgradeRewardTypes[upgradeReward].image}.png" id="${upgradeReward}">
                    </div>
                `
            }
        }
        else{
            upgradeIcon = 
            `
            <div class="upgradeIconBox" id="${upgradeReward}">
                <img class="upgradeIconImage" src="./images/upgradeIcons/empty.png" id="${upgradeReward}">
            </div>
            `
        }

        document.getElementById("upgradeSection"+upgradeRewardTypes[upgradeReward].rarity).insertAdjacentHTML("beforeend", upgradeIcon)
    }


    // PENGUINS
    for (let i = 0; i < upgradeData.length; i++){
        if(Object.keys(gameData.upgradeRewards).includes(String(i))){
            let imageName = upgradeData[String(i)].name
            const image = gameSkins[imageName]
            if(gameData.upgradeRewards[String(i)].amount > 0){
                upgradeIcon = `
                    <div class="upgradeIconBox" id="${i}">
                        <img class="upgradeIconImageClickablePenguin" src="${image}" id="${i}">
                        <div class="iconNum upgradeNum">${gameData.upgradeRewards[String(i)].amount}</div>
                    </div>
                `
            }else{
                upgradeIcon = `
                    <div class="upgradeIconBox" id="${i}">
                        <img class="upgradeIconImageClickablePenguin" src="${image}" id="${i}">
                    </div>
                `
            }

        }
        else{
            upgradeIcon = 
            `
            <div class="upgradeIconBox" id="${i}">
                <img class="upgradeIconImage" src="./images/upgradeIcons/empty.png" id="${i}">
            </div>
            `
        }

        document.getElementById("upgradeSectionPenguins").insertAdjacentHTML("beforeend", upgradeIcon)
    }
}

async function START(){
    let popupBackgrounds = document.getElementsByClassName('popup');
    for (let i= 0; i < popupBackgrounds.length; i++){
        popupBackgrounds.item(i).addEventListener('click', ()=>{popupBackgrounds.item(i).style.visibility = 'hidden'});
    }
    
    document.getElementById("treasureImageBox").addEventListener("click", ()=>{
        openBoxEffect()
    });
    window.addEventListener("click",removeBoxEffect)

    if(!signedIn){
        gameData = JSON.parse(localStorage.getItem("gameData"))
        upgrades = JSON.parse(localStorage.getItem("upgrades"))
    }else{
        await checkUserAgreement(userData)
    }

    gameData.upgradePoints += testingUpgradePoints

    // Getting gameInfo
    upgradeRewardTypes = gameInfo.upgradeRewardTypes
    upgradeData = gameInfo.upgradeData

    document.getElementById("penguinCoinAmount").innerHTML = gameData.upgradePoints
    
    createUpgrades()
    createActiveUpgrades()

    //calculateResetValue()

    //INIT_PenguinPass(gameData, skinsData, upgrades, signedIn)

    removeLoading()

    setInterval(mainLoop, 10);
}

async function CHECKUSER(user){
    await firebaseContent()

    if(user){
        signedIn = true
    }

    if(signedIn){
        const list = await getLists()

        if(list.cheaters.includes(auth.currentUser.uid) && signedIn){
            document.getElementById("CongratsYouWon").style.visibility = 'visible'
            removeLoading()
            document.getElementById('accountButton').addEventListener('click', ()=>{
                window.location.href = "account.html"
            })
        }

        let data = await getUserInfo('penguinclicker')
        userData = data[0]
        userGameData = data[1]

        if(userGameData.gameData){
            const localGameData = JSON.parse(localStorage.getItem("gameData"))
            if(localGameData){
                // sending home if there is still local storage
                window.location.href = "index.html"
            }else{
                gameData = userGameData.gameData
                upgrades = userGameData.upgrades
                START()
            }
        }else{
            // sending home if signed in and there is no gameData
            window.location.href = "index.html"
        }
        
    }else{
        START()
    }
}

async function initDarkMode(){
    darkMode = JSON.parse(localStorage.getItem("darkMode"))
    if(darkMode == null){
        // Check to see if Media-Queries are supported
        if (window.matchMedia) {
            // Check if the dark-mode Media-Query matches
            if(window.matchMedia('(prefers-color-scheme: dark)').matches){
                darkMode = true
            } else {
                darkMode = false
            }
        }
    }

    setDayNight()
}

async function INIT(){
    await initDarkMode()
    auth.onAuthStateChanged((user) => {
        CHECKUSER(user)
    });
    
}

window.addEventListener("load", () => {
    INIT()
});

function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled)
}

function printMousePos(event) {
    const clickEffect = document.createElement("div");

    clickEffect.classList.add("ClickEffectFixed")
    clickEffect.style.left = String((event.clientX)+'px')
    clickEffect.style.top = String((event.clientY)+'px')

    document.body.appendChild(clickEffect);

    setTimeout(()=>{
        clickEffect.remove();
    }, 200) 
}

async function upgradeElementClicked(e){
    let elementClass = e.target.className;

    // Removing buttons so they dont stack when inserting adjacent html
    try{
        document.getElementById("closePopup").remove()
        document.getElementById("activateReward").remove()
    }catch{}


    const rewardPopup = document.getElementById("rewardPopup")
    const rewardPopupBox = document.getElementById("rewardPopupBox")
    let descriptionBox = document.getElementById("descriptionBox")
    descriptionBox.innerHTML = ""
    const id = e.target.id
    const closebutton = `<button class="btn" id="closePopup" style="margin-top: 10px; background-color:  rgb(100, 100, 100);">CLOSE</button>`
    const activateButton = `<button class="btn" id="activateReward" style="margin-top: 10px; background-color:  rgb(90, 216, 73);">ACTIVATE</button>`

    if ((elementClass == 'upgradeIconImageClickable' || elementClass == 'upgradeIconImage') && Object.keys(gameData.upgradeRewards).includes(e.target.id)) {
        document.getElementById("rewardTitle").innerHTML = upgradeRewardTypes[id].name
        document.getElementById("rewardImage").src = `./images/upgradeIcons/${upgradeRewardTypes[id].image}.png`
        let newHtml = `<li>${upgradeRewardTypes[id].description}<br><br></li>`
        if(upgradeRewardTypes[id].duration){
            newHtml += `<li>Duration: ${upgradeRewardTypes[id].duration} Seconds</li>`
        }
        if(upgradeRewardTypes[id].multiply){
            newHtml += `<li>Multiply: X${upgradeRewardTypes[id].multiply}</li>`
        }
        if(upgradeRewardTypes[id].clickPercentage){
            newHtml += `<li>Per Click: +${Math.ceil(((gameData.penguinPerSecond*100) / upgradeRewardTypes[id].clickPercentage))} PPS</li>`
        }
        if(upgradeRewardTypes[id].spawnChance){
            newHtml += `<li>Spawn Chance: +${upgradeRewardTypes[id].spawnChance}</li>`
        }
        if(upgradeRewardTypes[id].runOffline){
            newHtml += `<br><li>Runs Offline for Logged in Players</li>`
        }

        descriptionBox.insertAdjacentHTML('beforeend',newHtml)

        let selectedUpgradeElements = document.getElementsByClassName('upgradeCountdown');
        
        const totalActiveUpgrades = checkUpgradeAmount()
        console.log(totalActiveUpgrades)
        if (totalActiveUpgrades < 3 && elementClass == 'upgradeIconImageClickable' && selectedUpgradeElements.length < 3){
            if (gameData.upgradeRewards[e.target.id].amount > 0 && canClick){
                rewardPopupBox.insertAdjacentHTML('beforeend',activateButton)
                document.getElementById("activateReward").addEventListener("click", ()=>{activateReward(e)})
            }
        }

        rewardPopupBox.insertAdjacentHTML('beforeend',closebutton)
        rewardPopup.style.visibility = "visible"
    }

    if (elementClass == 'upgradeIconImageClickablePenguin') {
        document.getElementById("rewardTitle").innerHTML = "FREE PENGUIN"
        document.getElementById("rewardImage").src = `./images/penguins/${upgradeData[id].name}.png`
        descriptionBox.insertAdjacentHTML('beforeend',`<li> Activate to recieve a free ${upgradeData[id].name} Penguin! </li>`)

        if (gameData.upgradeRewards[e.target.id].amount > 0 && canClick){
            rewardPopupBox.insertAdjacentHTML('beforeend',activateButton)
            document.getElementById("activateReward").addEventListener("click", ()=>{activateReward(e)})
        }

        rewardPopupBox.insertAdjacentHTML('beforeend',closebutton)
        rewardPopup.style.visibility = "visible"
    }
}

// this is so that the penguins are not counted toward total
function checkUpgradeAmount(){
    let total = 0
    for(const i in gameData.activeUpgrades){
        if(gameData.activeUpgrades[i].type != "penguin"){
            total += 1
        }
    }
    return total
}

async function activateReward(e){

    let elementClass = e.target.className;

    if (elementClass == 'upgradeIconImageClickable') {
        const totalActiveUpgrades = checkUpgradeAmount()
        if (totalActiveUpgrades < 3){

            if (gameData.upgradeRewards[e.target.id].amount > 0 && canClick){
                canClick = false
                
                gameData.activeUpgrades.push(
                    {
                        "name": e.target.id,
                        "timeElapsed": 0,
                        "type": "duration",
                        "id" : e.target.id + gameData.activeUpgrades.length
                    }
                )

                gameData.upgradeRewards[e.target.id].amount -= 1

                updateRewardElement(e.target.id, "", upgradeRewardTypes[e.target.id])

                if(!signedIn){
                    localStorage.setItem('gameData', JSON.stringify(gameData));
                }else{
                    syncData()
                }

                createActiveUpgrades()

                setTimeout(()=>{
                    canClick = true
                },100)

                //calculateResetValue()
            }
        }
    }

    if (elementClass == 'upgradeIconImageClickablePenguin') {

        if (gameData.upgradeRewards[e.target.id].amount > 0 && canClick){
            canClick = false

            let rewardObject = {
                rarity: "Penguin",
                image: upgradeData[e.target.id].name
            }

            gameData.activeUpgrades.push(
                {
                    "name": e.target.id,
                    "type": "penguin"
                }
            )

            gameData.upgradeRewards[e.target.id].amount -= 1
            upgrades[e.target.id].tempPrice = 0

            updateRewardElement(e.target.id, "Penguin", rewardObject)

            if(!signedIn){
                localStorage.setItem('gameData', JSON.stringify(gameData));
            }else{
                syncData()
            }
            
            setTimeout(()=>{
                canClick = true
            },100)
        }
    }
}

// Target all clicks on any element
document.addEventListener('click',(e) =>
{
    printMousePos(e)
    upgradeElementClicked(e)
});

// KEEP UPDATING PENGUINS
let storageCounter = 0

function mainLoop(){
    gameData.penguins += gameData.penguinPerSecond;
    
    if(!signedIn){
        storageCounter += 1
        if (storageCounter == 100){
            setLocalStorage()
            storageCounter = 0
        }
    }
}

function setLocalStorage(){
    gameData.Date = new Date();
    localStorage.setItem('gameData', JSON.stringify(gameData));
}

// SETTING SELECTED UPGRADES
function createActiveUpgrades(){

    let selectedupgradeboxes = document.getElementsByClassName('selectedupgradebox');
    let index = -1

    for (const activeupgrade in gameData.activeUpgrades){
        if(gameData.activeUpgrades[activeupgrade].type != "penguin"){
            index += 1
            let id = gameData.activeUpgrades[activeupgrade].id
            let name = gameData.activeUpgrades[activeupgrade].name

            const newUpgrade = `
            <div class="upgradeCountdown" id="${id}">
                <img class="activeUpgrade" src="./images/upgradeIcons/${name}.png">
            </div>
            `

            selectedupgradeboxes.item(index).innerHTML = ""
            selectedupgradeboxes.item(index).insertAdjacentHTML("beforeend", newUpgrade);
        }
    }
}

async function syncData(){
    if(signedIn){
        
        let highestUnlocked = 0
        for (let i = 0; i < upgrades.length; i++){
            if (!upgrades[i].locked){
                highestUnlocked += 1
            }
        }

        if(gameData.upgradePoints < 0){
            gameData.upgradePoints = 0;
        }

        const newGameInfo = {
            PPS : gameData.penguinPerSecond,
            equippedSkin : gameData.currentImg,
            highestUnlocked : highestUnlocked,
            lastLogin: Timestamp.now(),
            gameData: gameData,
            upgrades: upgrades
        }

        await updateGameInfo(newGameInfo)
        await updateUserLoginTime()
    }
}

async function firebaseContent(){
    skinsData = await getPenguinSkins()
    gameSkins = await loadGameSkins(skinsData)
}

function setDayNight(){
    const loadingBox = document.getElementById("loadingBox")
    const reportIssue = document.getElementById("loadingError")

    if(darkMode){
        document.body.style.backgroundColor = "#EEEEEE"
        document.body.style.color = "#000000"
        if(loadingBox){
            loadingBox.style.backgroundColor = "#EEEEEE"
            loadingBox.style.color = "#000000"
            reportIssue.style.color = "#000000"
        }
    }else{
        document.body.style.backgroundColor = "rgb(53, 53, 53)"
        document.body.style.color = "rgb(255, 187, 0)"
        if(loadingBox){
            loadingBox.style.backgroundColor = "rgb(53, 53, 53)"
            loadingBox.style.color = "rgb(255, 187, 0)"
            reportIssue.style.color = "rgb(255, 187, 0)"
        }
    }
}

// SEE IF YOU CAN GET IT TO HAVE THE OPEN ANIMATION FOR THE PENGUIN PASS
// UPDATE PAGE WHEN OPENING STUFF